import React, { useEffect, useState } from 'react';
import { Box, Typography, Sheet, Button } from '@mui/joy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

const ThankYou: React.FC = () => {


    const handleClose = () => {
        window.location.href = 'about:blank';
        window.close();
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.level1',
                p: 2
            }}
        >
            <Sheet
                variant="outlined"
                sx={{
                    maxWidth: '600px',
                    width: '100%',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                    borderRadius: 'lg',
                    borderColor: '#ea7a23',
                    position: 'relative'
                }}
            >
                <Button
                    variant="outlined"
                    color="neutral"
                    startDecorator={<CloseIcon sx={{ color: '#ea7a23' }} />}
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        borderColor: '#ea7a23',
                        color: '#ea7a23',
                        '&:hover': {
                            borderColor: '#d86a1f',
                            backgroundColor: 'rgba(234, 122, 35, 0.08)'
                        }
                    }}
                >
                    Close Tab
                </Button>

                <Box sx={{ width: '200px', mb: 2 }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/logo-vector.svg`}
                        alt="Vector India Logo"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </Box>

                <CheckCircleIcon
                    sx={{
                        fontSize: '4rem',
                        color: '#4CAF50'
                    }}
                />

                <Typography
                    level="h2"
                    sx={{
                        color: '#ea7a23',
                        textAlign: 'center',
                        fontSize: '2rem'
                    }}
                >
                    Thank You!
                </Typography>

                <Typography
                    level="body-lg"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center',
                        maxWidth: '400px',
                        mb: 2
                    }}
                >
                    Your exam has been submitted successfully. Our team will contact you soon.
                </Typography>
                <Typography level="body-sm" sx={{ mt: 2 }}>
                    For assistance, please contact: <br />
                    Email: <a href="mailto:admissions@vectorindia.org">admissions@vectorindia.org</a><br />
                    Hyderabad: <a href="tel:+919866666699">+91 98666 66699</a> <br />
                    Bangalore: <a href="tel:+918762456789">+91 87624 56789</a><br />
                    Chennai: <a href="tel:+919444222459">+91 94442 22459</a><br />
                </Typography>
            </Sheet>
        </Box>
    );
};

export default ThankYou;